/**
 * 主布局组件
 */

import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import { Sidebar } from "../components/Sidebar";
import "./MainLayout.css";

const { Content } = Layout;

export function MainLayout() {
  return (
    <Layout className="main-layout">
      {/* 侧边栏 */}
      <Sidebar />

      {/* 主内容区 */}
      <Layout>
        <Content
          className="keyboard-safe-container"
          style={{
            background: "var(--theme-layout-bg)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
